import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}
export function Input({
  label,
  className = '',
  ...props
}: InputProps) {
  return <div className="space-y-1.5" data-id="element-169">
      <label className="block text-sm font-medium text-slate-700" data-id="element-170">
        {label}
      </label>
      <input className={`
          w-full px-4 py-3 rounded-lg border border-slate-200 
          focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500
          placeholder:text-slate-400 text-slate-900 transition-all
          ${className}
        `} {...props} data-id="element-171" />
    </div>;
}